import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { postStreamItem } from '../../../api/items';

import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';
import { mergeItemWithUserData } from '../../../utils/items';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

import { POST_STREAM_ITEM_METHODS } from '../../../components/Items/constants/postStreamItemMethods';
import { REQUEST } from '../../../constants/request';

export const setItemCommentable = createAsyncThunk(
  'items/setItemCommentable',
  async ({ path, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [itemResponse, itemUserDataResponse] = await postStreamItem(
        {
          path,
          params: {
            ...params,
            method: POST_STREAM_ITEM_METHODS.commentable,
          },
        },
        {
          cancelToken: source.token,
        },
      );

      return mergeItemWithUserData(itemResponse, itemUserDataResponse);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const itemsStore = getState().items;

      return (
        itemsStore.items.item.actions.update.request[generateItemCIDKey(path)]
          ?.loading !== REQUEST.pending
      );
    },
  },
);

export const changeItemCommentableExtraReducers = builder => {
  builder
    .addCase(setItemCommentable.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.items.item.actions.update.request,
        action,
        generateItemCIDKey(action.meta.arg.path),
      );
    })
    .addCase(setItemCommentable.fulfilled, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.items.item.actions.update.request[itemCIDKey],
        action,
        () => {
          state.items.item.byId[itemCIDKey] = action.payload;

          if (!state.items.item.allIds.includes(itemCIDKey)) {
            state.items.item.allIds.push(itemCIDKey);
          }
        },
      );
    })
    .addCase(setItemCommentable.rejected, (state, action) => {
      handleRequestRejection(
        state.items.item.actions.update.request[
          generateItemCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
